import * as React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  Tooltip,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Checkbox,
  IconButton,
  Card,
  List,
  ListItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  DialogContent,
  DialogContentText,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
  InputAdornment,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useHubx } from "../../HubX";
import useConstructor from "../../core/hooks/useConstructor";
import { useSnackbar } from "notistack";
import {
  DELETE_INSTALLATION_GROUP,
  DO_SEND_RESET_PASSWORD,
  FETCH_INSTALLATION_GROUP,
  FETCH_DIRECTORIES,
  FETCH_ORGANIZATIONS,
  POST_INSTALLATION_GROUP,
  PUT_INSTALLATION_GROUP,
  DO_SEARCH_INSTALLATION,
} from "../../Fedx";
import includes from "lodash/includes";
import InstallationGroup, { EnrichedInstallationGroup } from "../../core/models/InstallationGroup";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import NavigateIcon from "../../assets/icons/NavigateIcon";
import DeleteIcon from "@material-ui/icons/Delete";
import EmailIcon from "@material-ui/icons/Email";
import UserIcon from "@material-ui/icons/AccountCircle";
import SearchIcon from "@material-ui/icons/Search";
import { isArrayValid, isEmailValid, padN } from "../../helpers/utility";
import { EMPTY_STRING_LABEL } from "../../core/constants/appGlobals";
import { formatDateTime, getDateFromTimezonePtBrToGMT } from "../../helpers/datetime";
import Permission, {
  APP_PERMISSIONS,
  DEFAULT_PERMISSION_LEVEL,
  getPermissionFromEnum,
  PermissionsType,
  PERMISSION_ACCESS_FREE_USER,
} from "../../core/models/Permission";
import NotificationChannelModel, {
  getNotificationChannelFromEnum,
  notificationChannel,
  NOTIFICATION_CHANNELS,
} from "../../core/models/NotificationChannel";
import NotificationRuleModel, {
  getNotificationRuleFromEnum,
  notificationRule,
  NOTIFICATION_RULES,
} from "../../core/models/NotificationRule";
import ResetIcon from "@material-ui/icons/Undo";
import CloseIcon from "@material-ui/icons/Close";
import BaseFilter from "../../core/models/BaseFilter";
import MaterialSelect from "../../components/MaterialSelect";
import { capitalize } from "lodash";
import SimpleTextField from "../../components/SimpleTextField";
import { ISaveInstallationGroup } from "../../core/contracts/ISaveInstallationGroup";
import { IEnumerable, NullableDate } from "../../core/models/ModelHelpers";
import User from "../../core/models/User";
import SimpleTable from "../../components/SimpleTable";
import { EMAIL_BLACK_LIST } from "../../core/constants/emailBlackList";
import { SessionCache } from "../../helpers/cache";
import {
  InstallationGroupEditMainCardButtonSkeleton,
  InstallationGroupEditAccordionSkeleton,
  BlockSkeleton,
} from "../../components/MaterialSkeleton";
import sortBy from "lodash/sortBy";
import InstallationModel from "../../core/models/Installation";
import { IInstallationRadix } from "../../core/contracts/IInstallation";
import MaterialDatePickerComponent from "../../components/MaterialDatePickerComponent";
import ButtonSwitch from "../../components/ButtonSwitch";
import { ADMIN, INTERNAL, SUPER_ADMIN } from "../../core/models/GroupTypeEnum";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiAccordionSummary-root": {
        backgroundColor: theme.customPaper.background.cardBackgroundLight,
        fontWeight: "bold",
      },
    },

    header: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "padding": theme.spacing(2),
      "background": theme.customPaper.background.cardBackgroundLightContrast,

      "& h2": {
        fontWeight: "bold",
        color: theme.palette.primary.main,
      },
    },

    buttonGroup: {
      "display": "flex",
      "columnGap": theme.spacing(2),

      "& button": {
        fontWeight: "bold",
      },
    },

    datePiker: {
      width: "150px",
    },

    expSwitch: {
      "margin-top": "2vh",
    },

    addNewLabel: {
      fontWeight: "bold",
      textDecoration: "underline",
    },

    textFieldWrapper: {
      display: "flex",
      alignItems: "center",
      columnGap: theme.spacing(1),
    },

    mainInfo: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(2, 4),
      justifyContent: "space-between",
    },

    hidden: {
      display: "none",
    },

    emailBtn: {
      marginRight: "1vw",
    },

    preferencesWrapper: {
      "display": "flex",
      "alignItems": "flex-start",
      "justifyContent": "space-between",
      "columnGap": theme.spacing(4),
      "flexWrap": "wrap",
      "flex": 1,

      "& > div": {
        flex: 1,
      },

      "& > div:first-child": {
        flex: 2,
      },

      "& h3": {
        color: theme.customPalette.text.primary,
        fontWeight: "bold",
      },
    },

    permissionContainer: {
      "flex": 1,
      "& >*:nth-child(6n + 4),>*:nth-child(6n + 5),>*:nth-child(6n + 6)": {
        backgroundColor: theme.customPaper.background.cardBackgroundLightContrast,
      },
    },

    preferenceContainer: {
      "& >*:nth-child(2n)": {
        backgroundColor: theme.customPaper.background.cardBackgroundLightContrast,
      },
    },

    checkBoxWrapper: {
      display: "flex",
      alignItems: "center",
      color: theme.customPalette.text.primary,
      fontWeight: "bold",
      
    },

    details: {
      flexDirection: "column",
      rowGap: `${theme.spacing(2)}px`,
    },
    detailsHeader: {
      display: "inline-flex",
      justifyContent: "space-between",
    },

    modalLabel: {
      fontSize: "smaller",
    },

    addEmailWrapper: {
      "display": "flex",
      "alignItems": "flex-start",
      "columnGap": theme.spacing(3),
      "justifyContent": "center",

      "& > div": {
        flex: 1,
      },
    },

    buttonSecondary: {
      color: theme.customPalette.text.darkgrey,
      textDecoration: "underline",
    },

    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
    },

    emailList: {
      "& svg": {
        color: theme.customPalette.text.primary,
      },

      "& .MuiListItem-gutters": {
        "border": `1px solid ${theme.customPalette.border.gray}`,

        "&:nth-child(odd)": {
          backgroundColor: theme.customPaper.background.cardBackgroundLight,
        },
      },

      "& .MuiListItemAvatar-root": {
        minWidth: theme.spacing(5),
      },
    },

    installationSectionsHeader: {
      fontSize: "1.5rem",
      background: theme.customPaper.background.cardBackgroundLight,
      padding: theme.spacing(1),
      fontWeight: "bold",
      color: theme.customPalette.text.primary,
    },

    searchSectionWrapper: {
      marginTop: theme.spacing(3),
      display: "flex",
      flexDirection: "column",
    },

    searchLabel: {
      color: theme.customPalette.text.primary,
    },

    searchWrapper: {
      display: "flex",
      alignItems: "center",
      columnGap: `${theme.spacing(2)}px`,
      padding: theme.spacing(2, 3),
    },

    searchField: {
      display: "flex",
    },

    maxSizeTable: {
      maxHeight: "30vh",
      overflow: "auto",
    },

    removeButton: {
      width: "fit-content",
    },

    renameButton: {
      marginRight: 10,
    },

    infoIcon: {
      fontSize: "0.75em",
    },
  })
);

const blankState = {
  active: true,
  groupType: 0,
  name: "",
  organization: "",
  directorShip: "",
  installationList: [],
  notificationChannelList: [],
  notificationRuleList: [],
  userList: [],
  permissionList: [],
  expirationDate: undefined,
  isAdmin: false,
  isInternal: false,
};

type EditInstallationGroup = Omit<Omit<InstallationGroup, "id">, "createUser"> & {
  id?: IEnumerable;
  createUser?: User;
  installations?: InstallationModel[];
};

function EditAdmin() {
  const [isLoadingInstallationGroup, setIsLoadingInstallationGroup] = React.useState<boolean>(
    false
  );

  const [isLoadingDeleteResponse, setIsLoadingDeleteResponse] = React.useState<boolean>(false);
  const [isLoadingSaveResponse, setIsLoadingSaveResponse] = React.useState<boolean>(false);
  const [loadingEmailResponseIds, setLoadingEmailResponseIds] = React.useState<IEnumerable[]>([]);
  const [loadingSearch, setLoadingSearch] = React.useState<boolean>(false);

  const [originalInstallationGroup, setOriginalInstallationGroup] = React.useState<
    EditInstallationGroup | EnrichedInstallationGroup
  >(blankState);
  const [installationGroup, setInstallationGroup] = React.useState<
    EditInstallationGroup | EnrichedInstallationGroup
  >(blankState);
  const [modalConfirmOpen, setModalConfirmOpen] = React.useState<boolean>(false);
  const [modalDeleteOpen, setModalDeleteOpen] = React.useState<boolean>(false);
  const [organizations, setOrganizations] = React.useState<string[]>([]);
  const [directories, setDirectories] = React.useState<string[]>([]);

  const [newOrganization, setNewOrganization] = React.useState<boolean>(false);
  const [newDirectorShip, setNewDirectorShip] = React.useState<boolean>(false);
  const [selectedUsersIds, setSelectedUsersIds] = React.useState<(IEnumerable | undefined)[]>([]);
  const [selectedInstallationIds, setSelectedInstallationIds] = React.useState<IEnumerable[]>([]);
  const [usersSignUpPending, setUsersSignUpPending] = React.useState<string[]>([]);

  const [expValue, setExpValue] = React.useState<boolean>(false);

  const [openUserDialog, setOpenUserDialog] = React.useState<boolean>(false);
  const [openInstallationDialog, setOpenInstallationDialog] = React.useState<boolean>(false);
  const [openRenameDialog, setOpenRenameDialog] = React.useState<boolean>(false);

  const [emailInput, setEmailInput] = React.useState<string>("");
  const [tempEmails, setTempEmails] = React.useState<
    { email: string; createDate: string; receiveNotification: true; userName?: string }[]
  >([]);

  const [renameInput, setRenameInput] = React.useState<string>("");
  const [searchInput, setSearchInput] = React.useState<string>("");
  const [searchInstallationsBuffer, setSearchInstallationsBuffer] = React.useState<
    InstallationModel[]
  >([]);
  const [searchInstallations, setSearchInstallations] = React.useState<InstallationModel[]>([]);
  const [selectedNewInstallationsIds, setSelectedNewInstallationsIds] = React.useState<
    IEnumerable[]
  >([]);

  const currentAdmin: User | undefined = React.useMemo(() => {
    const cache = new SessionCache();
    const userInfo: User | null = cache.get("user");

    if (userInfo) {
      return userInfo;
    }
  }, []);

  const history = useHistory();
  const routeParams = useParams();
  const toastr = useSnackbar();
  const hub = useHubx();

  const installationGroupId = get(routeParams, "installation_group_id");
  const newInstallation = Boolean(!installationGroupId);

  const registerIsEqualToOriginal = isEqual(installationGroup, originalInstallationGroup);

  const selectedUsersArrayIsValid = React.useMemo(() => isArrayValid(selectedUsersIds), [
    selectedUsersIds,
  ]);

  const areAllUsersSelected = React.useMemo(() => {
    const allUserIds = installationGroup?.userList?.map((x) => x.id);

    if (!selectedUsersArrayIsValid || !isArrayValid(allUserIds)) {
      return false;
    }

    return allUserIds?.every((x) => selectedUsersIds.includes(x));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installationGroup.userList, selectedUsersIds]);

  const isSuperAdminOrCreatedUser: boolean | undefined = React.useMemo(() => {
    const cache = new SessionCache();
    const userInfo: User | null = cache.get("user");

    if (userInfo) {
      const isSuperAdmin = !!userInfo.installationGroup?.find(
        (x) => x?.groupType?.toString() === SUPER_ADMIN.toString()
      );
      const isCreatedUser = !!userInfo.installationGroup?.find(
        (x) =>
          x?.id?.toString() === installationGroupId?.toString() &&
          x?.createUser?.id?.toString() === userInfo.id?.toString()
      );

      return isSuperAdmin || isCreatedUser;
    }
  }, []);

  const isAdminEditingAdminOrSuperAdmin: boolean | undefined = React.useMemo(() => {
    const cache = new SessionCache();
    const userInfo: User | null = cache.get("user");

    if (userInfo) {
      return (
        // É Admin
        !!userInfo.installationGroup?.find((x) => x?.groupType.toString() === ADMIN.toString()) &&
        // Não é SuperAdmin
        !userInfo.installationGroup?.find(
          (x) => x?.groupType?.toString() === SUPER_ADMIN.toString()
        ) &&
        // Editando Grupo de Admin ou de SuperAdmin
        (installationGroup?.groupType?.toString() === ADMIN.toString() ||
          installationGroup?.groupType?.toString() === SUPER_ADMIN.toString())
      );
    }
  }, [installationGroup]);

  const areAllInstallationsSelected = React.useMemo(() => {
    const allInstallationsIds =
      installationGroup?.installationList?.map((x) => x.installationId) ?? [];
    return allInstallationsIds.every((x) => x && selectedInstallationIds.includes(x));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installationGroup.installationList, selectedInstallationIds]);

  const areAllSearchInstallationsSelected = React.useMemo(() => {
    if (!isArrayValid(selectedNewInstallationsIds)) {
      return false;
    }

    const allInstallationsIds = searchInstallations?.map((x) => x.installation_id) ?? [];
    return allInstallationsIds.every((x) => selectedNewInstallationsIds.includes(x));
  }, [searchInstallations, selectedNewInstallationsIds]);

  const currentInstallationsRows = React.useMemo(() => {
    return installationGroup.installationList.map((installation) => {
      const installationInfo = installationGroup?.installations?.find(
        (x) => x.installation_id === installation.installationId
      );
      if (installationInfo) {
        return {
          installation_id: installation.installationId,
          createdDate: installation.createdDate,
          createdUser: installation.createdUser,
          name: installationInfo.name,
          numberOfThanks: installationInfo.number_of_tanks,
          product: installationInfo.product_code,
        };
      }

      return {
        installation_id: installation.installationId,
        createdDate: installation.createdDate,
        createdUser: installation.createdUser,
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installationGroup.installationList]);

  const redirectToAdminPage = () => {
    history.push("/admin/");
  };

  const handleClickBack = () => {
    if (registerIsEqualToOriginal) {
      redirectToAdminPage();
    } else {
      setModalConfirmOpen(true);
    }
  };

  const handleClickExpDate = (date: NullableDate) => {
    setInstallationGroup({
      ...installationGroup,
      expirationDate: getDateFromTimezonePtBrToGMT(date?.toString(), true),
    });
  };

  const handleClickExpSwitch = () => {
    setInstallationGroup({ ...installationGroup, expirationDate: undefined });
    setExpValue(!expValue);
  };

  const handleChangeInstallationGroupName = (e: React.ChangeEvent<{ value: string }>) => {
    setInstallationGroup({ ...installationGroup, name: e.target.value });
  };

  const checkPermission = (permission: PermissionsType) => {
    if (installationGroup.permissionList?.find((x) => x.type === permission)) {
      return true;
    }
    return false;
  };

  const isFreeUser = checkPermission(PERMISSION_ACCESS_FREE_USER);

  const handleClickFreeUserPermission = () => {
    if (isFreeUser) {
      setInstallationGroup({
        ...installationGroup,
        permissionList:
          installationGroup.permissionList?.filter(
            (x) => x.type !== PERMISSION_ACCESS_FREE_USER
          ) ?? [],
      });
    } else {
      setInstallationGroup({
        ...installationGroup,
        permissionList: [{ level: DEFAULT_PERMISSION_LEVEL, type: PERMISSION_ACCESS_FREE_USER }],
      });
    }
  };

  const handleClickPermission = (permission: PermissionsType) => {
    if (installationGroup.permissionList?.find((x) => x.type === permission)) {
      const newPermissionList = sortBy(
        installationGroup.permissionList?.filter((x) => x.type !== permission),
        "type"
      );
      setInstallationGroup({ ...installationGroup, permissionList: newPermissionList });
    } else {
      let newPermission: Permission = { level: DEFAULT_PERMISSION_LEVEL, type: permission };
      const permissionInOriginalRegister = originalInstallationGroup.permissionList?.find(
        (x) => x.level === DEFAULT_PERMISSION_LEVEL && x.type === permission
      );

      if (permissionInOriginalRegister) {
        newPermission = permissionInOriginalRegister;
      }

      setInstallationGroup({
        ...installationGroup,
        permissionList: sortBy(
          [...(installationGroup?.permissionList || []), newPermission],
          "type"
        ),
      });
    }
  };

  const checkNotificationChannel = (channel: notificationChannel) => {
    if (installationGroup.notificationChannelList?.find((x) => x.notificationChannel === channel)) {
      return true;
    }
    return false;
  };

  const handleClickNotificationChannel = (channel: notificationChannel) => {
    if (installationGroup.notificationChannelList?.find((x) => x.notificationChannel === channel)) {
      const newChannelsList = sortBy(
        installationGroup.notificationChannelList?.filter((x) => x.notificationChannel !== channel),
        "notificationChannel"
      );
      setInstallationGroup({ ...installationGroup, notificationChannelList: newChannelsList });
    } else {
      const newChannels: NotificationChannelModel = { id: 0, notificationChannel: channel };

      setInstallationGroup({
        ...installationGroup,
        notificationChannelList: sortBy(
          [...(installationGroup?.notificationChannelList || []), newChannels],
          "notificationChannel"
        ),
      });
    }
  };

  const checkNotificationRule = (rule: notificationRule) => {
    if (installationGroup.notificationRuleList?.find((x) => x.notificationRule === rule)) {
      return true;
    }
    return false;
  };

  const handleClickNotificationRule = (rule: notificationRule) => {
    if (installationGroup.notificationRuleList?.find((x) => x.notificationRule === rule)) {
      const newRuleList = sortBy(
        installationGroup.notificationRuleList?.filter((x) => x.notificationRule !== rule),
        "notificationRule"
      );
      setInstallationGroup({ ...installationGroup, notificationRuleList: newRuleList });
    } else {
      const newRuleList: NotificationRuleModel = { id: 0, notificationRule: rule };

      setInstallationGroup({
        ...installationGroup,
        notificationRuleList: sortBy(
          [...(installationGroup?.notificationRuleList || []), newRuleList],
          "notificationRule"
        ),
      });
    }
  };

  const handleClickDelete = () => {
    setModalDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    setIsLoadingDeleteResponse(true);
    try {
      await hub.request(DELETE_INSTALLATION_GROUP, installationGroup.id);
      toastr.enqueueSnackbar("O grupo de instalação foi excluído com sucesso!", {
        variant: "success",
      });
      redirectToAdminPage();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("EditAdmin → handleConfirmDelete -> error", error);
      toastr.enqueueSnackbar("Ops! Não foi possível deletar o grupo de instalação!", {
        variant: "error",
      });
    } finally {
      setIsLoadingDeleteResponse(false);
    }
  };

  const handleClickSave = async () => {
    setIsLoadingSaveResponse(true);
    try {
      const saveForm: ISaveInstallationGroup = installationGroup as ISaveInstallationGroup;

      await hub.request(
        newInstallation ? POST_INSTALLATION_GROUP : PUT_INSTALLATION_GROUP,
        saveForm
      );

      toastr.enqueueSnackbar(
        `O grupo de instalação foi ${newInstallation ? "criado" : "atualizado"} com sucesso!`,
        { variant: "success" }
      );

      redirectToAdminPage();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("EditAdmin → handleClickSave -> error", error?.data?.message ?? error);

      if (error?.data?.message) {
        toastr.enqueueSnackbar(error?.data?.message, { variant: "error" });
      } else {
        toastr.enqueueSnackbar(
          `Ops! Ocorreu um erro ao tentar ${
            newInstallation ? "criar" : "atualizar"
          } o grupo de instalação!`,
          { variant: "error" }
        );
      }
    } finally {
      setIsLoadingSaveResponse(false);
    }
  };

  const organizationTextFieldHasErrorDef = () => {
    if (!newOrganization) {
      return !installationGroup.organization;
    }

    return (
      !installationGroup.organization ||
      includes(
        organizations.map((x) => x?.trimLeft()?.trimRight()?.toLocaleLowerCase()),
        installationGroup?.organization?.trimLeft()?.trimRight()?.toLocaleLowerCase()
      )
    );
  };

  const organizationTextFieldHasError = organizationTextFieldHasErrorDef();

  const directorShipTextFieldHasErrorDef = () => {
    if (!newDirectorShip) {
      return !installationGroup.directorShip;
    }

    return (
      !installationGroup.directorShip ||
      includes(
        directories.map((x) => x?.trimLeft()?.trimRight()?.toLocaleLowerCase()),
        installationGroup?.directorShip?.trimLeft()?.trimRight()?.toLocaleLowerCase()
      )
    );
  };

  const directorShipTextFieldHasError = directorShipTextFieldHasErrorDef();

  const formErrors = () => {
    const messages = [];
    if (!newInstallation && registerIsEqualToOriginal) {
      messages.push("Nenhuma mudança foi feita ao grupo de instalação");
    }

    if (!installationGroup.name) {
      messages.push("Forneça um nome ao grupo de instalações!");
    }

    if (!installationGroup.organization) {
      messages.push("Selecione ou crie uma nova organização!");
    } else if (organizationTextFieldHasError) {
      messages.push("A Nova Organização já está cadastrada!");
    }

    if (!installationGroup.directorShip) {
      messages.push("Selecione ou crie uma nova diretoria!");
    } else if (directorShipTextFieldHasError) {
      messages.push("A Nova Diretoria já está cadastrada!");
    }

    if (isArrayValid(messages)) {
      return (
        <List>
          {messages.map((m, idx) => (
            <ListItem key={`save-error-message-${idx}`}>{m}</ListItem>
          ))}
        </List>
      );
    }

    return "Clique aqui para salvar as alterações";
  };

  const shouldDisableSave = (): boolean => {
    if (
      !registerIsEqualToOriginal &&
      installationGroup.name &&
      installationGroup.installationList &&
      !organizationTextFieldHasError &&
      !directorShipTextFieldHasError
    ) {
      return false;
    }

    return true;
  };

  const isNotLindeEmailSpecialGroups = (userEmail: string) => {
    if (
      (installationGroup?.groupType === ADMIN ||
        installationGroup?.groupType === INTERNAL ||
        installationGroup?.groupType === SUPER_ADMIN) &&
      !userEmail.includes("@linde")
    ) {
      return true;
    }
    return false;
  };

  const handleChangeOrganization = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;

    if (newValue === "new") {
      setInstallationGroup({ ...installationGroup, organization: "" });
      return setNewOrganization(true);
    }

    setInstallationGroup({ ...installationGroup, organization: capitalize(newValue) });
  };

  const handleChangeDirectorShip = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;

    if (newValue === "new") {
      setInstallationGroup({ ...installationGroup, directorShip: "" });
      return setNewDirectorShip(true);
    }

    setInstallationGroup({ ...installationGroup, directorShip: capitalize(newValue) });
  };

  const handleChangeManual = (e: React.ChangeEvent<{ value: string }>, propertyName: string) => {
    const newValue = e.target.value;
    setInstallationGroup({ ...installationGroup, [propertyName]: newValue });
  };

  const handleClickReset = (propertyName: "organization" | "directorShip") => {
    setInstallationGroup({
      ...installationGroup,
      [propertyName]: originalInstallationGroup[propertyName],
    });
    if (propertyName === "organization") {
      setNewOrganization(false);
    } else {
      setNewDirectorShip(false);
    }
  };

  const handleClickReSendEmail = async (userEmail?: string) => {
    if (!userEmail) {
      return;
    }
    setLoadingEmailResponseIds([...loadingEmailResponseIds, userEmail]);
    try {
      await hub.request(DO_SEND_RESET_PASSWORD, userEmail);
      toastr.enqueueSnackbar("E-mail re-enviado com sucesso!", { variant: "success" });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("EditAdmin → handleClickReSendEmail -> error", error);
      toastr.enqueueSnackbar(
        "Ops! Ocorreu um erro ao tentar encaminhar um novo e-mail para este usuário!",
        { variant: "error" }
      );
    } finally {
      setLoadingEmailResponseIds(loadingEmailResponseIds.filter((x) => x !== userEmail));
    }
  };

  const handleSelectUser = (userId: IEnumerable | undefined) => {
    if (selectedUsersIds.includes(userId)) {
      return setSelectedUsersIds(selectedUsersIds.filter((x) => x !== userId));
    }

    return setSelectedUsersIds([...selectedUsersIds, userId]);
  };

  const handleClickDeleteUsers = () => {
    if (!selectedUsersArrayIsValid) {
      return;
    }

    const newUsersOnGroup = sortBy(
      installationGroup?.userList?.filter((x) =>
        x.id ? !selectedUsersIds.includes(x.id) : !selectedUsersIds.includes(x?.email)
      ),
      "email"
    );
    setInstallationGroup({ ...installationGroup, userList: newUsersOnGroup });
    setSelectedUsersIds([]);
  };

  const handleClickResendEmail = () => {
    const usersToSend = usersSignUpPending;
    setUsersSignUpPending([]);

    usersToSend.forEach((email) => {
      handleClickReSendEmail(email);
    });
  };

  const handleSelectInstallation = (installationId: IEnumerable) => {
    if (!installationId) {
      return;
    }

    if (selectedInstallationIds.includes(installationId)) {
      return setSelectedInstallationIds(
        selectedInstallationIds.filter((x) => x !== installationId)
      );
    }

    return setSelectedInstallationIds([...selectedInstallationIds, installationId]);
  };

  const handleClickUserNotification = (user: User, newPreference: boolean) => {
    setInstallationGroup({
      ...installationGroup,
      userList: sortBy(
        [
          ...(installationGroup.userList?.filter((x) => x.email !== user.email) ?? []),
          { ...user, receiveNotification: newPreference },
        ],
        "email"
      ),
    });
  };

  const renderGroupUsers = () => {
    const currentUsers = sortBy(installationGroup?.userList, "email");

    if (isArrayValid(currentUsers)) {
      return currentUsers?.map((user, idx) => {
        const isSelected = user.id
          ? selectedUsersIds.includes(user.id)
          : selectedUsersIds.includes(user.email);

        return (
          <TableRow selected={isSelected} key={`user-${user.id || `auto-${idx}`}`}>
            <TableCell align="center" padding="checkbox">
              <Checkbox
                checked={isSelected}
                onClick={() => handleSelectUser(user.id || user.email)}
              />
            </TableCell>
            <TableCell align="center">{user.email || EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">{user.name || EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">
              {user.createDate ? formatDateTime(new Date(user.createDate)) : EMPTY_STRING_LABEL}
            </TableCell>
            <TableCell align="center">
              {user.registrationDate ? (
                formatDateTime(new Date(user.registrationDate))
              ) : user.id ? (
                loadingEmailResponseIds.includes(user?.email ?? "") ? (
                  <CircularProgress />
                ) : (
                  <Button variant="outlined" onClick={() => handleClickReSendEmail(user.email)}>
                    Reenviar e-mail de cadastro
                  </Button>
                )
              ) : (
                <Typography>Novo cadastro</Typography>
              )}
            </TableCell>
            <TableCell align="center">{user.createdUser?.name ?? EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">
              <Checkbox
                checked={user.receiveNotification}
                onClick={() => handleClickUserNotification(user, !user.receiveNotification)}
              />
            </TableCell>
          </TableRow>
        );
      });
    }

    return null;
  };

  const handleClickSelectAllUsers = () => {
    const allUserIds =
      installationGroup?.userList?.map((x) => x.id || x.email || "").filter((x) => x) ?? [];

    // Empty selection → select all
    if (!selectedUsersArrayIsValid) {
      return setSelectedUsersIds(allUserIds);
    }

    // all users selected → deselect all
    if (areAllUsersSelected) {
      return setSelectedUsersIds([]);
    }

    // some are selected → select all
    return setSelectedUsersIds(allUserIds);
  };

  const handleClickSelectAllInstallations = () => {
    const allInstallationsIds =
      installationGroup?.installationList?.map((x) => x.installationId || "")?.filter((x) => x) ??
      [];

    // Empty selection → select all
    if (!isArrayValid(selectedInstallationIds)) {
      return setSelectedInstallationIds(allInstallationsIds);
    }

    // all users selected → deselect all
    if (areAllInstallationsSelected) {
      return setSelectedInstallationIds([]);
    }

    // some are selected → select all
    return setSelectedInstallationIds(allInstallationsIds);
  };

  const currentInstallationSelected = React.useMemo(() => {
    if (selectedInstallationIds.length == 1) {
      const selectedId = selectedInstallationIds[0];
      const installationInfo = cloneDeep(
        originalInstallationGroup?.installations?.find((x) => x.installation_id === selectedId)
      );

      const installationRadix = cloneDeep(
        installationGroup?.installationList.find((x) => x.installationId === selectedId)
      );

      setRenameInput(installationRadix?.name || installationInfo?.name || "");
      return { original: installationInfo, radix: installationRadix };
    }
    return null;
  }, [selectedInstallationIds, originalInstallationGroup, installationGroup]);

  const renameTextFieldHasErrorDef = () => {
    if (renameInput == currentInstallationSelected?.radix?.name) {
      return false;
    }

    const installationRadix = includes(
      installationGroup?.installationList.map((x) => x.name?.toLowerCase().trimLeft()?.trimRight()),
      renameInput.toLowerCase()
    );

    const originalInstallation = includes(
      originalInstallationGroup?.installations?.map((x) =>
        x.name?.toLowerCase().trimLeft()?.trimRight()
      ),
      renameInput.toLowerCase()
    );

    return installationRadix || originalInstallation;
  };

  const renameTextFieldHasError = renameTextFieldHasErrorDef();

  const renderGroupInstallations = () => {
    const currentInstallations = installationGroup.installationList;

    if (isArrayValid(currentInstallations)) {
      return currentInstallations?.map((installation, idx) => {
        // if Installation doesn't have Id it has ben added now
        const installationInfo =
          installation.id !== undefined
            ? originalInstallationGroup?.installations?.find(
                (x) => x.installation_id === installation.installationId
              )
            : searchInstallationsBuffer.find(
                (x) => x.installation_id === installation.installationId
              );
        const groupCurrentInstalationInfo = installationGroup.installationList.find(
          (x) => x.installationId === installation.installationId
        );
        const isSelected = selectedInstallationIds.includes(installation.installationId || "");

        return (
          <TableRow
            selected={isSelected}
            key={`installation-${installation.installationId || `auto-${idx}`}`}
          >
            <TableCell align="center" padding="checkbox">
              <Checkbox
                checked={isSelected}
                onClick={() => handleSelectInstallation(installation.installationId || "")}
              />
            </TableCell>
            <TableCell align="center">
              {groupCurrentInstalationInfo?.name ? (
                <>
                  {groupCurrentInstalationInfo.name}{" "}
                  <Tooltip title={installationInfo?.name || ""}>
                    <InfoIcon className={classes.infoIcon} />
                  </Tooltip>
                </>
              ) : (
                installationInfo?.name || EMPTY_STRING_LABEL
              )}
            </TableCell>
            <TableCell align="center">
              {installationInfo?.number_of_tanks || EMPTY_STRING_LABEL}
            </TableCell>
            <TableCell align="center">
              {installationInfo?.product_code || EMPTY_STRING_LABEL}
            </TableCell>
            <TableCell align="center">
              {installation.installationId || EMPTY_STRING_LABEL}
            </TableCell>
            <TableCell align="center">
              {installation.createdDate
                ? formatDateTime(new Date(installation.createdDate))
                : EMPTY_STRING_LABEL}
            </TableCell>
            <TableCell align="center">
              {installation.createdUser?.name || currentAdmin?.name || EMPTY_STRING_LABEL}
            </TableCell>
          </TableRow>
        );
      });
    }

    return null;
  };

  const handleClickDeleteInstallations = () => {
    if (!isArrayValid(selectedInstallationIds)) {
      return;
    }

    const newInstallationsOnGroup = sortBy(
      installationGroup.installationList.filter(
        (x) => !selectedInstallationIds.includes(x.installationId || "")
      ),
      "installationId"
    );
    setInstallationGroup({ ...installationGroup, installationList: newInstallationsOnGroup });
    setSelectedInstallationIds([]);
  };

  const handleCloseUserModal = () => {
    setOpenUserDialog(false);
    setEmailInput("");
    setTempEmails([]);
  };

  const handleCloseInstallationModal = () => {
    setOpenInstallationDialog(false);
    setSearchInput("");
    setSearchInstallations([]);
    setSelectedNewInstallationsIds([]);
  };

  const handleCloseRenameModal = () => {
    setOpenRenameDialog(false);
    setRenameInput("");
  };

  const handleRevertRenameModal = () => {
    setOpenRenameDialog(false);
    const current = currentInstallationSelected?.radix;
    if (current) {
      delete current.name;

      const installationIndex = installationGroup?.installationList.findIndex(
        (x) => x.installationId == current?.installationId
      );

      const installationListAux = cloneDeep(installationGroup.installationList);

      installationListAux[installationIndex] = current;

      setInstallationGroup((prev) => {
        return { ...prev, installationList: installationListAux };
      });
    }
  };

  const handleClickModalConfirm = () => {
    redirectToAdminPage();
  };

  const currentEmailAlreadyInGroup = React.useMemo(() => {
    const allEmails =
      installationGroup?.userList?.map((user) => user.email?.toLocaleLowerCase()) ?? [];

    return includes(allEmails, emailInput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailInput, installationGroup.userList]);

  const currentEmailAlreadyInTemp = React.useMemo(() => {
    const allTempEmails = tempEmails.map((x) => x.email);

    return includes(allTempEmails, emailInput);
  }, [emailInput, tempEmails]);

  const validateEmailInput = React.useCallback((): boolean => {
    const emailIsValid = isEmailValid(emailInput);
    if (emailIsValid && !currentEmailAlreadyInGroup && !currentEmailAlreadyInTemp) {
      const domain = emailInput.split("@").pop();
      const blackListTest = EMAIL_BLACK_LIST.reduce((prev, currentBlackListDomain) => {
        return prev || includes(domain, currentBlackListDomain);
      }, false);

      return !blackListTest;
    }

    return false;
  }, [currentEmailAlreadyInGroup, currentEmailAlreadyInTemp, emailInput]);

  const handleClickAddAllEmails = () => {
    setInstallationGroup({
      ...installationGroup,
      userList: [...(installationGroup?.userList ?? []), ...(tempEmails as User[])],
    });
    setOpenUserDialog(false);
    setTempEmails([]);
  };

  const handleClickAddEmail = () => {
    setTempEmails([
      ...tempEmails,
      {
        email: emailInput,
        createDate: new Date().toISOString(),
        receiveNotification: true,
        userName: emailInput,
      },
    ]);
    setEmailInput("");
  };

  const handleClickSearch = async () => {
    setLoadingSearch(true);
    try {
      const APIResponse: InstallationModel[] = await hub.request(
        DO_SEARCH_INSTALLATION,
        searchInput
      );
      if (isArrayValid(APIResponse)) {
        setSearchInstallations(APIResponse);
      } else {
        setSearchInstallations([]);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("EditAdmin → handleClickSearch -> error", error);
      toastr.enqueueSnackbar("Ops! Ocorreu um erro ao tentar buscar as instalações!", {
        variant: "error",
      });
    } finally {
      setLoadingSearch(false);
    }
  };

  const handleClickRenameInstallations = () => {
    const current = currentInstallationSelected?.radix;

    if (current) {
      current.name = renameInput;

      const installationIndex = installationGroup?.installationList.findIndex(
        (x) => x.installationId == current?.installationId
      );

      const installationListAux = cloneDeep(installationGroup.installationList);

      installationListAux[installationIndex] = current;

      setInstallationGroup((prev) => {
        return { ...prev, installationList: installationListAux };
      });
    }
    handleCloseRenameModal();
  };

  const handleClickAddNewInstallations = () => {
    if (isArrayValid(selectedNewInstallationsIds)) {
      const selectedInstallations = searchInstallations.filter((x) =>
        selectedNewInstallationsIds.includes(x.installation_id)
      );

      const newInstallations: IInstallationRadix[] = selectedInstallations.map((x) => {
        return {
          createdDate: new Date().toISOString(),
          installationId: x.installation_id,
        } as IInstallationRadix;
      });

      setInstallationGroup({
        ...installationGroup,
        installationList: uniqBy(
          [...installationGroup.installationList, ...newInstallations],
          "installationId"
        ),
      });
      setSearchInstallationsBuffer([...searchInstallationsBuffer, ...selectedInstallations]);
    }

    handleCloseInstallationModal();
  };

  const handleSelectNewInstallation = (installation_id: IEnumerable) => {
    if (selectedNewInstallationsIds.includes(installation_id)) {
      return setSelectedNewInstallationsIds(
        selectedNewInstallationsIds.filter((x) => x !== installation_id)
      );
    }

    return setSelectedNewInstallationsIds([...selectedNewInstallationsIds, installation_id]);
  };

  const handleSelectALLNewInstallation = () => {
    const allInstallationsIds = searchInstallations?.map((x) => x.installation_id) ?? [];

    // Empty selection → select all
    if (!isArrayValid(selectedNewInstallationsIds)) {
      return setSelectedNewInstallationsIds(allInstallationsIds);
    }

    // all users selected → deselect all
    if (areAllSearchInstallationsSelected) {
      return setSelectedNewInstallationsIds([]);
    }

    // some are selected → select all
    return setSelectedNewInstallationsIds(allInstallationsIds);
  };

  const renderSearchInstallations = () => {
    if (isArrayValid(searchInstallations)) {
      return searchInstallations?.map((installation, idx) => {
        const isSelected = includes(selectedNewInstallationsIds, installation.installation_id);

        return (
          <TableRow
            selected={isSelected}
            key={`search-installation-${installation.installation_id}`}
          >
            <TableCell align="center" padding="checkbox">
              <Checkbox
                checked={isSelected}
                onClick={() => handleSelectNewInstallation(installation.installation_id)}
              />
            </TableCell>
            <TableCell align="center">{installation?.name || EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">{installation.installation_id}</TableCell>
            <TableCell align="center">{installation?.product_code || EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">{installation?.has_rtu ? "Sim" : "Não"}</TableCell>
            <TableCell align="center">{installation?.rtu_vendor || EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">{installation.address ?? EMPTY_STRING_LABEL}</TableCell>
            <TableCell align="center">
              {installation?.number_of_tanks || EMPTY_STRING_LABEL}
            </TableCell>
          </TableRow>
        );
      });
    }

    return null;
  };

  useConstructor(async () => {
    const fetchDirectories = async () => {
      try {
        const APIResponse: string[] = await hub.request(FETCH_DIRECTORIES);
        const useDirectorShips = uniqBy(APIResponse, function (o) {
          return o?.trimLeft()?.trimRight()?.toLocaleLowerCase();
        });

        setDirectories(useDirectorShips);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("AdminPageFilter → fetchDirectories → error", error);
        toastr.enqueueSnackbar(
          "Ops! Ocorreu um problema ao tentar obter as opções cadastradas de diretorias!",
          { variant: "error" }
        );
      }
    };

    const fetchOrganizations = async () => {
      try {
        const APIResponse: string[] = await hub.request(FETCH_ORGANIZATIONS);

        const useOrganizations = uniqBy(APIResponse, function (o) {
          return o?.trimLeft()?.trimRight()?.toLocaleLowerCase();
        });

        setOrganizations(useOrganizations);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("AdminPageFilter → fetchDirectories → error", error);
        toastr.enqueueSnackbar(
          "Ops! Ocorreu um problema ao tentar obter as opções cadastradas de organizações!",
          { variant: "error" }
        );
      }
    };

    const fetchInstallationGroup = async () => {
      if (installationGroupId) {
        setIsLoadingInstallationGroup(true);
        try {
          const APIResponse: InstallationGroup = await hub.request(
            FETCH_INSTALLATION_GROUP,
            installationGroupId
          );
          setOriginalInstallationGroup(APIResponse);
          setInstallationGroup(APIResponse);
          setExpValue(APIResponse.expirationDate ? true : false);
          setIsLoadingInstallationGroup(false);

          const usersPending = APIResponse.userList?.reduce((filtered: string[], op) => {
            if (!op.registrationDate && op.username) {
              filtered.push(op.username);
            }
            return filtered;
          }, []);

          if (usersPending && isArrayValid(usersPending)) {
            setUsersSignUpPending(usersPending);
          }
        } catch (error) {
          toastr.enqueueSnackbar(
            "Ops! Ocorreu um erro ao tentar obter as informações deste grupo de instalações! Abortando...",
            { variant: "error" }
          );
          redirectToAdminPage();
        }
      }
    };

    fetchDirectories();
    fetchOrganizations();
    fetchInstallationGroup();
  });

  const classes = useStyles();
  const emailIsValid = React.useMemo(() => validateEmailInput(), [validateEmailInput]);

  const failSafeOrganizationItems = React.useMemo(() => {
    let useOrganizations =
      organizations?.sort().map((x) => {
        return { key: x.toLocaleLowerCase(), value: x };
      }) ?? [];

    if (
      (!isArrayValid(useOrganizations) && installationGroup?.organization) ||
      (installationGroup?.organization &&
        !organizations
          .map((x) => x.toLocaleLowerCase())
          .includes(installationGroup?.organization?.toLocaleLowerCase()))
    ) {
      useOrganizations = [
        ...useOrganizations,
        {
          key: installationGroup?.organization?.toLocaleLowerCase() ?? "",
          value: installationGroup?.organization ?? "",
        },
      ];
    }

    return [
      {
        key: "new",
        value: <Typography className={classes.addNewLabel}>Adicionar Novo</Typography>,
      },
      ...useOrganizations,
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizations, installationGroup?.organization]);

  const failSafeDirectorShipsItems = React.useMemo(() => {
    let useDirectorShips =
      directories?.sort().map((x) => {
        return { key: x.toLocaleLowerCase(), value: x };
      }) ?? [];

    if (
      (!isArrayValid(useDirectorShips) && installationGroup?.directorShip) ||
      (installationGroup?.directorShip &&
        !directories
          .map((x) => x.toLocaleLowerCase())
          .includes(installationGroup?.directorShip?.toLocaleLowerCase()))
    ) {
      useDirectorShips = [
        ...useDirectorShips,
        {
          key: installationGroup?.directorShip?.toLocaleLowerCase() ?? "",
          value: installationGroup?.directorShip ?? "",
        },
      ];
    }

    return [
      {
        key: "new",
        value: <Typography className={classes.addNewLabel}>Adicionar Novo</Typography>,
      },
      ...useDirectorShips,
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [directories, installationGroup?.directorShip]);

  const organizationSelect: BaseFilter = {
    id: "organizacao",
    items: failSafeOrganizationItems,
    label: "",
    value: installationGroup?.organization?.toLocaleLowerCase(),
    handleChange: handleChangeOrganization,
  };

  const directorShipSelect: BaseFilter = {
    id: "diretoria",
    items: failSafeDirectorShipsItems,
    label: "",
    value: installationGroup?.directorShip?.toLocaleLowerCase(),
    handleChange: handleChangeDirectorShip,
  };

  if (isLoadingInstallationGroup) {
    return (
      <Container className={classes.root} maxWidth={"xl"}>
        <div>
          <Tooltip title="Voltar para página de administração de grupos de instalações">
            <Button onClick={handleClickBack}>
              <NavigateIcon transform="rotate(-180)" /> <strong>Voltar</strong>
            </Button>
          </Tooltip>
        </div>
        <Grid container direction="column">
          <Grid item>
            <div className={classes.header}>
              <Typography component="h2">Edição de Grupo de Instalação</Typography>

              <div className={classes.buttonGroup}>
                <InstallationGroupEditMainCardButtonSkeleton />
                <InstallationGroupEditMainCardButtonSkeleton />
              </div>
            </div>
            <Card>
              <InstallationGroupEditAccordionSkeleton />
            </Card>
          </Grid>

          <Grid item xs={12}>
            <InstallationGroupEditAccordionSkeleton />
          </Grid>
          <Grid item xs={12}>
            <InstallationGroupEditAccordionSkeleton />
          </Grid>
          <Grid item xs={12}>
            <InstallationGroupEditAccordionSkeleton />
          </Grid>
        </Grid>
      </Container>
    );
  }

  return (
    <>
      <Container className={classes.root} maxWidth={"xl"}>
        <div>
          <Tooltip title="Voltar para página de administração de grupos de instalações">
            <Button onClick={handleClickBack}>
              <NavigateIcon transform="rotate(-180)" /> <strong>Voltar</strong>
            </Button>
          </Tooltip>
        </div>

        <div>
          <div>
            <div className={classes.header}>
              <Typography component="h2">
                {newInstallation
                  ? "Adição de Grupo de Instalação"
                  : "Edição de Grupo de Instalação"}
              </Typography>

              <div className={classes.buttonGroup}>
                {!newInstallation &&
                  !(installationGroup.groupType === ADMIN) &&
                  !(installationGroup.groupType === SUPER_ADMIN) &&
                  !(installationGroup.groupType === INTERNAL) && (
                    <Tooltip
                      title={
                        !isSuperAdminOrCreatedUser
                          ? "Apenas usuários SuperAdmin conseguem excluir grupos de instalação que não criaram"
                          : "Clique para deletar esse grupo de instalação"
                      }
                    >
                      <span>
                        <Button
                          disabled={
                            isLoadingSaveResponse ||
                            isLoadingDeleteResponse ||
                            !isSuperAdminOrCreatedUser
                          }
                          disableElevation
                          variant="contained"
                          onClick={handleClickDelete}
                        >
                          Excluir
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                {isLoadingSaveResponse ? (
                  <CircularProgress />
                ) : (
                  <Tooltip title={formErrors()}>
                    <span>
                      <Button
                        disabled={shouldDisableSave()}
                        disableElevation
                        variant="contained"
                        onClick={handleClickSave}
                      >
                        Salvar Alterações
                      </Button>
                    </span>
                  </Tooltip>
                )}
              </div>
            </div>

            <Card
              className={
                installationGroup?.groupType === ADMIN ||
                installationGroup?.groupType === INTERNAL ||
                installationGroup?.groupType === SUPER_ADMIN
                  ? classes.hidden
                  : classes.mainInfo
              }
            >
              <div>
                <Typography>Organização</Typography>
                {newOrganization ? (
                  <div className={classes.textFieldWrapper}>
                    <SimpleTextField
                      value={installationGroup.organization}
                      handleChange={(e) => handleChangeManual(e, "organization")}
                      error={organizationTextFieldHasError}
                      helperText={
                        (!installationGroup.organization && "Preencha a nova organização") ||
                        (organizationTextFieldHasError &&
                          "A Nova Organização fornecida já está cadastrada! Por favor, a selecione a partir da lista de opções!")
                      }
                    />

                    <Tooltip title="Descartar mudanças e voltar para seleção de organização">
                      <IconButton onClick={() => handleClickReset("organization")}>
                        <ResetIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  <MaterialSelect filter={organizationSelect} canEdit={true} />
                )}
              </div>

              <div>
                <Typography>Grupo de Instalação</Typography>

                <SimpleTextField
                  value={installationGroup.name}
                  handleChange={handleChangeInstallationGroupName}
                  error={!installationGroup.name}
                  helperText={
                    installationGroup.name ? "" : "Forneça um nome para o grupo de instalação"
                  }
                />
              </div>

              <div>
                <Typography>Diretoria</Typography>
                {newDirectorShip ? (
                  <div className={classes.textFieldWrapper}>
                    <SimpleTextField
                      value={installationGroup.directorShip}
                      handleChange={(e) => handleChangeManual(e, "directorShip")}
                      error={directorShipTextFieldHasError}
                      helperText={
                        (!installationGroup.directorShip && "Preencha a nova diretoria") ||
                        (directorShipTextFieldHasError &&
                          "A Nova Diretoria fornecida já está cadastrada! Por favor, a selecione a partir da lista de opções!")
                      }
                    />

                    <Tooltip title="Descartar mudanças e voltar para seleção de diretoria">
                      <IconButton onClick={() => handleClickReset("directorShip")}>
                        <ResetIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  <MaterialSelect filter={directorShipSelect} canEdit={true} />
                )}
              </div>

              <div className={classes.expSwitch}>
                <ButtonSwitch
                  label="Este grupo expira?"
                  onLabel="Sim"
                  offLabel="Não"
                  onClick={handleClickExpSwitch}
                  value={expValue}
                />
              </div>
              <div className={expValue ? classes.datePiker : classes.hidden}>
                <Typography>Data de Expiração</Typography>
                <MaterialDatePickerComponent
                  clearable
                  value={
                    installationGroup.expirationDate
                      ? new Date(installationGroup.expirationDate)
                      : null
                  }
                  minDateMessage={"A data de expiração não pode ser menor que hoje"}
                  minDate={new Date()}
                  onChange={handleClickExpDate}
                />
              </div>

              {!newInstallation && (
                <div>
                  <Typography>Usuários ativos</Typography>
                  <Typography>
                    {(originalInstallationGroup?.userList?.length &&
                      padN(originalInstallationGroup?.userList?.length)) ||
                      0}
                  </Typography>
                </div>
              )}

              <div>
                <Typography>Data de inclusão</Typography>
                <Typography>
                  {newInstallation
                    ? formatDateTime(new Date())
                    : (originalInstallationGroup?.createDate &&
                        formatDateTime(new Date(originalInstallationGroup.createDate))) ||
                      EMPTY_STRING_LABEL}
                </Typography>
              </div>

              <div>
                <Typography>Criado por</Typography>
                <Typography>
                  {newInstallation
                    ? currentAdmin?.name ?? EMPTY_STRING_LABEL
                    : originalInstallationGroup?.createUser?.name ?? EMPTY_STRING_LABEL}
                </Typography>
              </div>
            </Card>
          </div>

          <Accordion
            className={
              installationGroup?.groupType === ADMIN ||
              installationGroup?.groupType === INTERNAL ||
              installationGroup?.groupType === SUPER_ADMIN
                ? classes.hidden
                : ""
            }
          >
            <AccordionSummary>Preferências</AccordionSummary>
            <AccordionDetails>
              <div className={classes.preferencesWrapper}>
                <div>
                  <Typography component="h3">Permissões</Typography>
                  <div className={classes.checkBoxWrapper}>
                    <Checkbox
                      checked={isFreeUser}
                      onClick={handleClickFreeUserPermission}
                    />
                    <Typography>{getPermissionFromEnum(PERMISSION_ACCESS_FREE_USER)}</Typography>
                  </div>
                  <Grid className={classes.permissionContainer} container>
                    {APP_PERMISSIONS.filter(
                      (x) => x !== 1 && x !== 9 && x !== PERMISSION_ACCESS_FREE_USER
                    ).map((permission) => {
                      return permission ? (
                        <Grid key={permission} item xs={4}>
                          <div className={classes.checkBoxWrapper}>
                            <Checkbox
                              disabled={isFreeUser}
                              checked={checkPermission(permission)}
                              onClick={() => handleClickPermission(permission)}
                            />
                            <Typography>{getPermissionFromEnum(permission)}</Typography>
                          </div>
                        </Grid>
                      ) : null;
                    })}
                  </Grid>
                </div>

                <div>
                  <Typography component="h3">Canais de Notificação</Typography>

                  <Grid direction="column" className={classes.preferenceContainer} container>
                    {NOTIFICATION_CHANNELS.map((channel) => (
                      <Grid key={channel} item>
                        <div className={classes.checkBoxWrapper}>
                          <Checkbox
                            checked={checkNotificationChannel(channel)}
                            onClick={() => handleClickNotificationChannel(channel)}
                          />
                          <Typography>{getNotificationChannelFromEnum(channel)}</Typography>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>

                <div>
                  <Typography component="h3">Tipos de Notificação</Typography>

                  <Grid direction="column" className={classes.preferenceContainer} container>
                    {NOTIFICATION_RULES.map((rule) => (
                      <Grid key={rule} item>
                        <div className={classes.checkBoxWrapper}>
                          <Checkbox
                            checked={checkNotificationRule(rule)}
                            onClick={() => handleClickNotificationRule(rule)}
                          />
                          <Typography>{getNotificationRuleFromEnum(rule)}</Typography>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary>Usuários</AccordionSummary>
            <AccordionDetails className={classes.details}>
              <div className={classes.detailsHeader}>
                <Tooltip
                  title={
                    isAdminEditingAdminOrSuperAdmin
                      ? "Apenas usuários SuperAdmin podem remover usuários deste grupo de instalação"
                      : selectedUsersArrayIsValid
                      ? "Remover os usuários selecionados do grupo de instalação"
                      : "Nenhum usuário selecionado"
                  }
                >
                  <span>
                    <Button
                      disabled={isAdminEditingAdminOrSuperAdmin || !selectedUsersArrayIsValid}
                      onClick={handleClickDeleteUsers}
                      variant="outlined"
                    >
                      <DeleteIcon />
                      Excluir Selecionados
                    </Button>
                  </span>
                </Tooltip>

                <div>
                  <Tooltip
                    className={classes.emailBtn}
                    title={
                      usersSignUpPending
                        ? "Reenviar e-mail de cadastro para todos os usuários com cadastro pendente"
                        : "Nenhum usuário com cadastro pendente"
                    }
                  >
                    <span>
                      <Button
                        disabled={!isArrayValid(usersSignUpPending)}
                        onClick={handleClickResendEmail}
                        variant="outlined"
                      >
                        <EmailIcon />
                        Reenviar todos os convites pendentes
                      </Button>
                    </span>
                  </Tooltip>

                  <Tooltip
                    title={
                      isAdminEditingAdminOrSuperAdmin
                        ? "Apenas usuários SuperAdmin podem adicionar usuários a este grupo de instalação"
                        : ""
                    }
                  >
                    <span>
                      <Button
                        onClick={() => setOpenUserDialog(true)}
                        disabled={isAdminEditingAdminOrSuperAdmin}
                        variant="outlined"
                      >
                        Adicionar Usuário
                      </Button>
                    </span>
                  </Tooltip>
                </div>
              </div>

              <div>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" padding="checkbox">
                        <Checkbox
                          checked={areAllUsersSelected}
                          onClick={handleClickSelectAllUsers}
                        />
                      </TableCell>
                      <TableCell align="center">E-mail</TableCell>
                      <TableCell align="center">Nome</TableCell>
                      <TableCell align="center">Data de Inclusão</TableCell>
                      <TableCell align="center">Data de Cadastro</TableCell>
                      <TableCell align="center">Criado por</TableCell>
                      <TableCell align="center">Receber Notificações</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>{renderGroupUsers()}</TableBody>
                </Table>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            className={
              installationGroup?.groupType === ADMIN ||
              installationGroup?.groupType === INTERNAL ||
              installationGroup?.groupType === SUPER_ADMIN
                ? classes.hidden
                : ""
            }
          >
            <AccordionSummary>Instalações</AccordionSummary>
            <AccordionDetails className={classes.details}>
              <div className={classes.detailsHeader}>
                <div className={classes.removeButton}>
                  <Tooltip
                    title={
                      isArrayValid(selectedInstallationIds)
                        ? "Excluir do grupo as instalações selecionadas"
                        : "Nenhuma instalação selecionada"
                    }
                  >
                    <span>
                      <Button
                        onClick={handleClickDeleteInstallations}
                        disabled={!isArrayValid(selectedInstallationIds)}
                        variant="outlined"
                      >
                        <DeleteIcon />
                        Excluir Selecionados
                      </Button>
                    </span>
                  </Tooltip>
                </div>
                <div>
                  <Tooltip
                    title={
                      isArrayValid(selectedInstallationIds) && selectedInstallationIds.length > 1
                        ? "Escolha apenas uma instalação para renomear"
                        : selectedInstallationIds.length == 1
                        ? ""
                        : "Nenhuma instalação selecionada"
                    }
                  >
                    <span>
                      <Button
                        onClick={() => setOpenRenameDialog(true)}
                        disabled={selectedInstallationIds.length != 1}
                        variant="outlined"
                        className={classes.renameButton}
                      >
                        Renomear
                      </Button>
                    </span>
                  </Tooltip>
                  <Button onClick={() => setOpenInstallationDialog(true)} variant="outlined">
                    Adicionar Instalação
                  </Button>
                </div>
              </div>

              <div>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" padding="checkbox">
                        <Checkbox
                          checked={areAllInstallationsSelected}
                          onClick={handleClickSelectAllInstallations}
                        />
                      </TableCell>
                      <TableCell align="center">Nome Fantasia</TableCell>
                      <TableCell align="center">Número de Tanques</TableCell>
                      <TableCell align="center">Produto</TableCell>
                      <TableCell align="center">#Nº White</TableCell>
                      <TableCell align="center">Data de Inclusão</TableCell>
                      <TableCell align="center">Adicionado por</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>{renderGroupInstallations()}</TableBody>
                </Table>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </Container>

      {/* Confirm changes dialog */}
      <Dialog open={modalConfirmOpen}>
        <DialogTitle>Descartar Alterações?</DialogTitle>
        <DialogActions>
          <Button className={classes.buttonSecondary} onClick={() => setModalConfirmOpen(false)}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleClickModalConfirm}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Delete dialog */}
      <Dialog open={modalDeleteOpen}>
        <DialogTitle>Confirmação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span>Tem certeza que deseja excluir este grupo de instação? Essa ação é </span>
            <strong>PERMANENTE E IRREVERSÍVEL</strong>
            <span>. Deseja continuar?</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.buttonSecondary}
            disabled={isLoadingDeleteResponse}
            onClick={() => setModalDeleteOpen(false)}
          >
            Cancelar
          </Button>

          {isLoadingDeleteResponse ? (
            <CircularProgress />
          ) : (
            <Button variant="contained" onClick={handleConfirmDelete}>
              Confirmar
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Add user Modal */}
      <Dialog maxWidth="sm" fullWidth open={openUserDialog} onClose={handleCloseUserModal}>
        <DialogTitle>
          Adicionar Usuário
          <IconButton className={classes.closeButton} onClick={handleCloseUserModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.modalLabel}>
            Por favor, utilize somente e-mails corporativos
          </DialogContentText>
          <div className={classes.addEmailWrapper}>
            <SimpleTextField
              value={emailInput}
              fullWidth
              onChange={(e) => setEmailInput(e.target.value.toLocaleLowerCase())}
              placeholder="Digite o E-mail"
              InputProps={{ type: "email" }}
              autoComplete="on"
              error={
                (!emailIsValid && emailInput !== "") || isNotLindeEmailSpecialGroups(emailInput)
              }
              helperText={
                !emailIsValid
                  ? currentEmailAlreadyInGroup
                    ? "Este e-mail já está cadastrado"
                    : currentEmailAlreadyInTemp
                    ? "Este e-mail já foi adicionado"
                    : isEmailValid(emailInput)
                    ? "Forneça um e-mail corporativo"
                    : emailInput === ""
                    ? ""
                    : "E-mail inválido!"
                  : isNotLindeEmailSpecialGroups(emailInput)
                  ? "Só podem ser adicionados e-mails @linde neste grupo de instalação"
                  : ""
              }
            />

            <Button
              onClick={handleClickAddEmail}
              disabled={!emailIsValid || isNotLindeEmailSpecialGroups(emailInput)}
              variant="outlined"
            >
              Adicionar
            </Button>
          </div>

          <div>
            <List className={classes.emailList}>
              {tempEmails.map((user, idx) => (
                <ListItem key={`new-user-${idx}`}>
                  <ListItemAvatar>
                    <UserIcon />
                  </ListItemAvatar>
                  <ListItemText>{user.email}</ListItemText>
                </ListItem>
              ))}
            </List>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className={classes.buttonSecondary} onClick={handleCloseUserModal}>
            Cancelar
          </Button>
          <Tooltip title={isArrayValid(tempEmails) ? "" : "Forneça ao menos um e-mail"}>
            <span>
              <Button
                disabled={!isArrayValid(tempEmails)}
                variant="contained"
                onClick={handleClickAddAllEmails}
              >
                Confirmar
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>

      {/* Add installation Modal */}
      <Dialog
        maxWidth="lg"
        fullWidth
        open={openInstallationDialog}
        onClose={handleCloseInstallationModal}
      >
        <DialogTitle>
          Adicionar Instalação
          <IconButton className={classes.closeButton} onClick={handleCloseInstallationModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Card>
            <div>
              <Typography className={classes.installationSectionsHeader} component="h3">
                Instalações Atuais
              </Typography>
            </div>
            <div className={classes.maxSizeTable}>
              <SimpleTable
                header={[
                  "Nome Fantasia",
                  "Número de Tanques",
                  "Produto",
                  "# Nº White",
                  "Data de Inclusão",
                  "Adicinado por",
                ]}
                rows={currentInstallationsRows.map((x) => {
                  const cachedNewInstallation = searchInstallationsBuffer.find(
                    (y) => x.installation_id === y.installation_id
                  );

                  return [
                    x?.name || cachedNewInstallation?.name || EMPTY_STRING_LABEL,
                    x.numberOfThanks ||
                      cachedNewInstallation?.number_of_tanks ||
                      EMPTY_STRING_LABEL,
                    x.product || cachedNewInstallation?.product_code || EMPTY_STRING_LABEL,
                    x.installation_id,
                    x.createdDate ? formatDateTime(new Date(x.createdDate)) : EMPTY_STRING_LABEL,
                    x.createdUser?.name || currentAdmin?.name || EMPTY_STRING_LABEL,
                  ];
                })}
              />
            </div>
          </Card>

          <div className={classes.searchSectionWrapper}>
            <div>
              <Typography className={classes.installationSectionsHeader} component="h3">
                Buscar Instalações
              </Typography>
            </div>
            <div className={classes.searchWrapper}>
              <Typography className={classes.searchLabel}>Nome Fantasia ou Número White</Typography>
              <div className={classes.searchField}>
                <SimpleTextField
                  value={searchInput}
                  handleChange={(e) => setSearchInput(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button onClick={handleClickSearch} variant="outlined">
                  Buscar
                </Button>
              </div>
            </div>

            <div>
              {loadingSearch ? (
                <BlockSkeleton />
              ) : (
                isArrayValid(searchInstallations) && (
                  <div>
                    <Table className={classes.maxSizeTable} stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" padding="checkbox">
                            <Checkbox
                              checked={areAllSearchInstallationsSelected}
                              onClick={handleSelectALLNewInstallation}
                            />
                          </TableCell>
                          <TableCell align="center">Nome Fantasia</TableCell>
                          <TableCell align="center"># Nº White</TableCell>
                          <TableCell align="center">Produto</TableCell>
                          <TableCell align="center">Possui RTU?</TableCell>
                          <TableCell align="center">Vendor</TableCell>
                          <TableCell align="center">Endereço</TableCell>
                          <TableCell align="center">Número de Tanques</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>{renderSearchInstallations()}</TableBody>
                    </Table>
                  </div>
                )
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className={classes.buttonSecondary} onClick={handleCloseInstallationModal}>
            Cancelar
          </Button>

          <Tooltip
            title={
              isArrayValid(selectedNewInstallationsIds) ? "" : "Nenhuma instalação nova selecionada"
            }
          >
            <span>
              <Button
                disabled={!isArrayValid(selectedNewInstallationsIds)}
                variant="contained"
                onClick={handleClickAddNewInstallations}
              >
                Confirmar
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
      {/* Rename Modal */}
      <Dialog maxWidth="lg" fullWidth open={openRenameDialog} onClose={handleCloseRenameModal}>
        <DialogTitle>
          Renomear Instalação
          <IconButton className={classes.closeButton} onClick={handleCloseRenameModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className={classes.searchSectionWrapper}>
            <SimpleTextField
              helperText={
                renameTextFieldHasError
                  ? "Ops! Essa instalação já existe nesse grupo"
                  : renameInput.length < 3 || renameInput.length > 25
                  ? "Tamanho minimo 3 caracteres e tamanho maximo 25 caracteres"
                  : ""
              }
              placeholder={
                currentInstallationSelected?.radix?.name
                  ? currentInstallationSelected?.radix?.name
                  : currentInstallationSelected?.original?.name
              }
              value={renameInput}
              handleChange={(e) => setRenameInput(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className={classes.buttonSecondary} onClick={handleCloseRenameModal}>
            Cancelar
          </Button>

          <Button className={classes.buttonSecondary} onClick={handleRevertRenameModal}>
            Reverter
          </Button>

          <span>
            <Button
              disabled={
                renameInput.length < 3 || renameInput.length > 25 || renameTextFieldHasError
              }
              variant="contained"
              onClick={handleClickRenameInstallations}
            >
              Confirmar
            </Button>
          </span>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditAdmin;
